import Objective from './objective/objective';
import Process from './process/process';
import ProcessingActivity from './processingActivity';
import Theme from './theme';

export class RiskContext {
  themes: Theme[];

  processes: Process[];

  objectives: Objective[];

  processingActivities: ProcessingActivity[];

  constructor() {
    this.objectives = [];
    this.themes = [];
    this.processes = [];
    this.processingActivities = [];
  }
}
